/* eslint-disable import/no-unresolved */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bool, func, number, arrayOf, shape, string } from "prop-types";
import { compose } from "redux";
import Yup from "yup";
import { Field, Form, withFormik } from "formik";
import Col from "react-bootstrap/lib/Col";
import { push } from "react-router-redux";
import moment from "moment";
import classNames from "classnames";
import { isIOS } from "react-device-detect";

import {
    actions as metrocorpActions,
    selectors as metrocorpSelectors,
    types as metrocorpTypes,
} from "reducers/metrocorp";
import { actions as globalActions } from "reducers/types/global";
import { selectors as statusSelectors } from "reducers/status";

import Container from "pages/_components/Container";
import Button from "pages/_components/Button";
import PageLoading from "pages/_components/PageLoading";
import Head from "pages/_components/Head";
import Notification from "pages/_components/Notification";
import { resizableRoute } from "pages/_components/Resizable";
import { DownloadButton } from "v3/components/DownloadButton";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
} from "util/v3ShellLayoutSync";
import EquivalentTotalBalance from "pages/metrocorp/_components/EquivalentTotalBalance";
import I18n from "pages/_components/I18n";
import Selector from "pages/_components/fields/formik/Selector";
import { DateField } from "pages/_components/fields/DateField";
import RangeDatePicker from "pages/_components/fields/rangedatepicker/RangeDatePicker";
import TabletSelectors from "pages/_components/TabletSelectors";
import MetrocorpMovementDetail from "pages/metrocorp/_components/MetrocorpMovementDetail";
import MetrocorpList from "pages/metrocorp/_components/MetrocorpList";
import Image from "pages/_components/Image";
import { ContextMenu } from "@ui-kit/components/index.es";
import MetrocorpExtractsConnected from "pages/metrocorp/_components/MetrocorpExtractsConnected";

import metrocorpTitleFirstPart from "styles/images/metrocorp-grey.svg";

import uniqBy from "lodash/uniqBy";
import * as i18nUtils from "util/i18n";
import * as configUtils from "util/config";
import { getRutPathAccount } from "util/accounts";
import { evalEqualsValues } from "util/form";
import { getPostLoginHomePath } from "util/v3UxConfig";
import { resolveMetrocorpFlowGoBackPath } from "util/fundcorp";

const FORM_ID = "metrocorp.list";

class MetrocorpMain extends Component {
    static propTypes = {
        fetching: bool.isRequired,
        isDesktop: bool.isRequired,
        dispatch: func.isRequired,
        handleSubmit: func.isRequired,
        fetchingDownload: bool.isRequired,
        activeTotal: number.isRequired,
        holdings: arrayOf(shape({})).isRequired,
        dateHoldings: arrayOf(shape({})).isRequired,
        futureValues: arrayOf(shape({})).isRequired,
        movements: arrayOf(shape({})).isRequired,
        fullMovementsList: arrayOf(shape({})).isRequired,
        fullMovementsListToDownload: arrayOf(shape({})),
        filtersData: shape({}).isRequired,
        values: shape({}).isRequired,
        clients: arrayOf(shape({})).isRequired,
        optionSelected: string.isRequired,
        setFieldValue: func.isRequired,
        location: shape({}).isRequired,
        isReportDrawerVisible: bool.isRequired,
        fechingReport: bool.isRequired,
        embeddedInV3Shell: bool,
        lastPathname: string.isRequired,
    };

    static defaultProps = {
        fullMovementsListToDownload: [],
        embeddedInV3Shell: false,
    };

    constructor(props) {
        super(props);
        const { values } = props;

        this.state = {
            isDisplayed: false,
            selectedDateFrom: null,
            currentDate: values.date,
            showForm: false,
            species: [],
            defaultAccount: "",
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        // Liberar spinner si quedó colgado tras un error de download (*E → /error).
        dispatch({ type: metrocorpTypes.DOWNLOAD_LIST_METROCORP_FAILURE });
        dispatch(metrocorpActions.listMetrocorpPre());
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const {
            dispatch,
            holdings,
            dateHoldings,
            futureValues,
            movements,
            clients,
            location,
            embeddedInV3Shell,
            isDesktop,
            fetchingDownload,
            fetching,
            isReportDrawerVisible,
            lastPathname,
        } = this.props;

        if (
            prevProps.holdings !== holdings ||
            prevProps.dateHoldings !== dateHoldings ||
            prevProps.futureValues !== futureValues ||
            prevProps.movements !== movements
        ) {
            this.updateSpecies();
        }
        if (prevProps.clients !== clients) {
            let defaultAccount = clients[0]?.codClie;
            if (location?.state?.idAccount) {
                defaultAccount = location?.state?.idAccount;
            }
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(() => ({
                defaultAccount,
            }));
            const selectedClient = clients.find((client) => client.codClie === defaultAccount);
            if (selectedClient) {
                dispatch(
                    metrocorpActions.listMetrocorp(
                        "holdings",
                        `${selectedClient.nombre} ${selectedClient.apellido}`,
                        selectedClient.codClie,
                        "all",
                        moment(),
                        moment(),
                        moment(),
                    ),
                );
            }
        }
        if (embeddedInV3Shell) {
            const shellOrViewportChanged =
                prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop;
            const pathDepsChanged =
                prevProps.location?.pathname !== location?.pathname ||
                prevProps.location?.state?.return !== location?.state?.return ||
                prevProps.lastPathname !== lastPathname;
            const mobileRightDepsChanged =
                !isDesktop &&
                (prevProps.fetchingDownload !== fetchingDownload ||
                    prevProps.fetching !== fetching ||
                    prevProps.isReportDrawerVisible !== isReportDrawerVisible ||
                    prevProps.clients !== clients);
            if (shellOrViewportChanged || pathDepsChanged || mobileRightDepsChanged) {
                this.syncEmbeddedV3ShellLayout();
            }
        }
    }

    componentWillUnmount() {
        const { dispatch, embeddedInV3Shell } = this.props;
        dispatch(globalActions.resetSelectedElements());
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    getResolvedMetrocorpGoBackPath = () => {
        const { location, lastPathname } = this.props;
        const returnFromState = location?.state?.return;
        if (returnFromState && returnFromState !== "/") {
            return returnFromState;
        }
        const fromLast = resolveMetrocorpFlowGoBackPath({
            returnFromState: undefined,
            lastHrefPathname: lastPathname,
            currentPathname: location?.pathname || "",
        });
        if (fromLast === "/metrocorp" && (location?.pathname || "") === "/metrocorp") {
            return getPostLoginHomePath(true);
        }
        return fromLast;
    };

    syncEmbeddedV3ShellLayout = () => {
        const {
            dispatch,
            embeddedInV3Shell,
            isDesktop,
            fetchingDownload,
            fetching,
            isReportDrawerVisible,
        } = this.props;
        const showDrawerExtract = configUtils.getBoolean("frontend.show.metrocorpExtracts.functionalities", false);
        let rightContentMobile;
        if (!isDesktop) {
            if (showDrawerExtract) {
                rightContentMobile = isReportDrawerVisible ? this.renderMetrocorpExtracts() : this.renderContextMenu();
            } else {
                rightContentMobile = (
                    <DownloadButton
                        handleClick={this.handleExport}
                        isFetchingExport={fetchingDownload}
                        downloadImageWhite={!fetching}
                    />
                );
            }
        }
        const resolvedGoBackPath = this.getResolvedMetrocorpGoBackPath();
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            syncDesktopShellHeader: true,
            scopes: ["metrocorp.list"],
            titleKey: "menu.metrocorp",
            goBackPath: resolvedGoBackPath,
            rightContentMobile: !isDesktop ? rightContentMobile : undefined,
        });
    };

    handleChangeDateFrom = (selectedDate) => {
        this.setState({ selectedDateFrom: selectedDate });
    };

    handleOpenBottomSheetClick = () => {
        this.setState({ isDisplayed: true });
    };

    handleCloseBottomSheetClick = () => {
        this.setState({ isDisplayed: false });
    };

    handleBack = () => {
        const { dispatch, location, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            dispatch(push(this.getResolvedMetrocorpGoBackPath()));
            return;
        }
        const returnTo = location?.state?.return;
        if (returnTo && returnTo !== "/") {
            dispatch(push(returnTo));
            return;
        }
        if (location?.state?.idAccount) {
            dispatch(push(getRutPathAccount()));
        } else {
            dispatch(push("/desktop"));
        }
    };

    handleExport = (format) => {
        const {
            dispatch,
            activeTotal,
            holdings,
            futureValues,
            fullMovementsList,
            fullMovementsListToDownload,
            filtersData,
            optionSelected,
        } = this.props;

        const enableFrontendPagination = configUtils.getBoolean("metrocorp.tenencia.tipo.functionalities", false);
        const enableDailyMovDownload = configUtils.getBoolean(
            "frontend.show.metrocorp.Adjustments.dailyMov.functionalities",
            false,
        );

        let movementsToExport =
            enableDailyMovDownload && fullMovementsListToDownload ? fullMovementsListToDownload : fullMovementsList;

        movementsToExport = movementsToExport || [];

        if (
            enableFrontendPagination &&
            optionSelected === "movements" &&
            movementsToExport &&
            movementsToExport.length > 0 &&
            filtersData
        ) {
            const species = filtersData.species || "all";

            if (species !== "all") {
                movementsToExport = movementsToExport.filter((m) => {
                    const movementSpecies = m.codEspe?.trim() || "";
                    const filterSpecies = species.trim();
                    return movementSpecies === filterSpecies;
                });
            }
        }

        const summary = {
            activeTotal,
            holdings,
            futureValues,
            movements: movementsToExport,
            fullMovementsList: movementsToExport,
            optionSelected,
            filtersData,
        };
        dispatch(metrocorpActions.downloadMetrocorpList(summary, format));
    };

    changeOption = (option) => {
        const { dispatch, setFieldValue, clients, filtersData, isDesktop } = this.props;
        const selectedClient = clients && clients.length > 0 ? clients[0].codClie : "";

        this.resetSpecies();

        setFieldValue("principalAccount", selectedClient);
        setFieldValue("species", "all");
        setFieldValue("date", moment());
        setFieldValue("dateFrom", moment());
        setFieldValue("dateTo", moment());
        setFieldValue("dates", [new Date(), new Date()]);

        dispatch(metrocorpActions.setLocalPage(1));

        dispatch(
            metrocorpActions.saveOptionSelected(
                option,
                selectedClient ? `${selectedClient.nombre} ${selectedClient.apellido}` : "",
                selectedClient ? selectedClient.codClie : "",
                "all",
                moment(),
                moment(),
                moment(),
            ),
        );
        if (option === "futureValues") {
            const directionFilter =
                filtersData.directionFilter === undefined ? "ascendent" : filtersData.directionFilter;
            dispatch(
                metrocorpActions.listMetrocorp(
                    option,
                    `${selectedClient.nombre} ${selectedClient.apellido}`,
                    selectedClient,
                    "all",
                    moment(),
                    moment(),
                    moment(),
                    1,
                    isDesktop,
                    directionFilter,
                ),
            );
        } else {
            dispatch(
                metrocorpActions.listMetrocorp(
                    option,
                    `${selectedClient.nombre} ${selectedClient.apellido}`,
                    selectedClient,
                    "all",
                    moment(),
                    moment(),
                    moment(),
                    1,
                ),
            );
        }
    };

    centerElement = () => {
        const { isDesktop } = this.props;

        if (isDesktop) {
            return (
                <div className="metrocorp__head">
                    <img src={metrocorpTitleFirstPart} alt="Metrocorp" className="metrocorp__brand" />
                    <h1 className="my-0 ml-2 px-1">|</h1>
                    <div className="ml-2">
                        <I18n id="metrocorp.title.secondPart" component="h1" componentProps={{ className: "my-0" }} />
                    </div>
                </div>
            );
        }
        return (
            <div
                className={classNames("metrocorp__head view-title data-wrapper-flex", "justify-content-center", {
                    "align-center": !isDesktop,
                })}>
                <div>
                    <I18n
                        id="metrocorp.title.secondPart"
                        component="h1"
                        componentProps={{ className: "cmf-title-center my-0" }}
                    />
                    <Image src="images/metrocorp-white.svg" className="metrocorp__brand" />
                </div>
            </div>
        );
    };

    modalDetail = () => {
        const { isDisplayed } = this.state;
        const { isDesktop } = this.props;

        return (
            <MetrocorpMovementDetail
                handleCloseBottomSheetClick={this.handleCloseBottomSheetClick}
                goBack={this.handleCloseBottomSheetClick}
                isDisplayed={isDisplayed}
                isDesktop={isDesktop}
            />
        );
    };

    rowButtons = () => {
        const { isDesktop, optionSelected } = this.props;
        const enableFutureValuesNewLabel = configUtils.getBoolean(
            "frontend.show.metrocorp.AdjustmentsVF.functionalities",
            false,
        );
        const possibleOptions = ["holdings", "futureValues", "movements"];
        const options = possibleOptions.map((possibleOption) => ({
            value: possibleOption,
            label: `metrocorp.${possibleOption}.label${
                possibleOption === "futureValues" && enableFutureValuesNewLabel ? ".new" : ""
            }`,
        }));

        return (
            <TabletSelectors
                isDesktop={isDesktop}
                possibleOptions={options}
                changeOption={this.changeOption}
                optionSelected={optionSelected}
                section="metrocorp"
                containerClass="metrocorp-tablet-selector py-25"
            />
        );
    };

    updateSpecies = () => {
        const newSpecies = this.getSpecies();

        this.setState((prevState) => ({
            species: uniqBy([...prevState.species, ...newSpecies], "label"),
        }));
    };

    resetSpecies = () => {
        this.setState({ species: [] });
    };

    onChangePrincipalAccount = (newAccount) => {
        const { setFieldValue } = this.props;
        setFieldValue("principalAccount", newAccount);
        this.resetSpecies();
    };

    getSpecies = () => {
        const { optionSelected, dateHoldings, holdings, futureValues, movements, fullMovementsList } = this.props;
        const enableFrontendPagination = configUtils.getBoolean("metrocorp.tenencia.tipo.functionalities", false);

        let dataSource = null;

        if (
            optionSelected === "movements" &&
            enableFrontendPagination &&
            fullMovementsList &&
            fullMovementsList.length > 0
        ) {
            dataSource = fullMovementsList;
        } else {
            const data = {
                holdings: holdings || dateHoldings,
                futureValues,
                movements,
            };
            dataSource = data[optionSelected];
        }

        if (!optionSelected || !dataSource || !Array.isArray(dataSource) || dataSource.length === 0) {
            return [];
        }

        return uniqBy(
            dataSource.map((item) => ({
                value: item.codEspe,
                label: item.codEspe + item.descripcionEspecie,
            })),
            "label",
        );
    };

    renderForm() {
        const {
            fetching,
            values,
            clients,
            optionSelected,
            handleSubmit,
            setFieldValue,
            isDesktop,
            filtersData,
            location,
        } = this.props;

        const { selectedDateFrom, showForm } = this.state;
        const { dateFrom, dateTo, principalAccount } = values;

        const principalAccounts = clients.map((client) => ({ value: client.codClie, label: client.codClie }));
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        const enableNewSubmitButton = configUtils.getBoolean("frontend.Show.FilterButton.Functionalities", false);

        if (!principalAccount && clients && clients.length > 0) {
            if (location?.state?.idAccount) {
                setFieldValue("principalAccount", location?.state?.idAccount);
            } else {
                setFieldValue("principalAccount", clients[0].codClie);
            }
        }

        const speciesDefault = {
            value: "all",
            label: i18nUtils.get(`${FORM_ID}.search.species.options.all`),
        };

        const { species } = this.state;
        const speciesToShow = [speciesDefault, ...species];

        const options = speciesToShow.map((speciesShow) => ({
            value: speciesShow.value,
            label: speciesShow.label,
        }));

        if (!options.find(({ value }) => value === values.species)) {
            setFieldValue("species", "all");
        }

        let mdCol = {};
        switch (optionSelected) {
            case "holdings":
                mdCol = {
                    account: 3,
                    species: 3,
                    date: 3,
                    dateTo: null,
                    dateFrom: null,
                    button: 3,
                };
                break;
            case "movements":
                mdCol = {
                    account: 6,
                    species: 6,
                    date: null,
                    dateTo: 4,
                    dateFrom: 4,
                    button: 4,
                };
                break;
            default:
                mdCol = {
                    account: 4,
                    species: 4,
                    date: null,
                    dateTo: null,
                    dateFrom: null,
                    button: 4,
                };
                break;
        }

        return (
            (isDesktop || showForm) && (
                <Form
                    onSubmit={async (e) => {
                        await handleSubmit(e);
                        this.setState({
                            showForm: false,
                            currentDate: values.date,
                        });
                    }}
                    autoComplete="off"
                    className={enableRangeDatefield ? "metrocorp__form_v2" : ""}>
                    <Container
                        className={classNames(
                            "align-items-left account-header-detail account-header-align-items-left",
                            { "background-transparent": !isDesktop },
                            { "py-3": isDesktop },
                        )}
                        gridClassName="form-content"
                        rowClassName={`justify-content-left align-items-start ${isIOS && "w-100 m-0"}`}>
                        <Col sm={12} md={mdCol.account} lg={3}>
                            <Field
                                component={Selector}
                                options={principalAccounts}
                                idForm={`${FORM_ID}.search`}
                                name="principalAccount"
                                isRequired
                                hidePlaceholder
                                controlLabelClassName="color-black"
                                onChange={(account) => {
                                    this.onChangePrincipalAccount(account.value);
                                }}
                            />
                        </Col>
                        <Col sm={12} md={mdCol.species} lg={3}>
                            <Field
                                component={Selector}
                                options={options}
                                idForm={`${FORM_ID}.search`}
                                name="species"
                                isRequired
                                controlLabelClassName="color-black"
                                searchable={isDesktop}
                                filterOption={(option, inputValue) =>
                                    option.label.toLowerCase().includes(inputValue.toLowerCase())
                                }
                            />
                        </Col>

                        {optionSelected === "holdings" && (
                            <Col sm={12} md={mdCol.date} lg={2}>
                                <Field
                                    component={DateField}
                                    idForm={`${FORM_ID}.search`}
                                    name="date"
                                    hidePlaceholder
                                    minDate={null}
                                    maxDate={moment()}
                                    isRequired
                                    controlLabelClassName="color-black"
                                />
                            </Col>
                        )}

                        {optionSelected === "movements" &&
                            (!enableRangeDatefield ? (
                                <>
                                    <Col sm={6} md={mdCol.dateFrom} lg={2} className="col-6">
                                        <Field
                                            component={DateField}
                                            idForm={`${FORM_ID}.search`}
                                            name="dateFrom"
                                            hidePlaceholder
                                            startDate={dateFrom}
                                            handleChange={this.handleChangeDateFrom}
                                            endDate={dateTo}
                                            isRequired
                                            minDate={null}
                                            controlLabelClassName="color-black"
                                        />
                                    </Col>
                                    <Col sm={6} md={mdCol.dateTo} lg={2} className="col-6">
                                        <Field
                                            component={DateField}
                                            hidePlaceholder
                                            idForm={`${FORM_ID}.search`}
                                            name="dateTo"
                                            minDate={selectedDateFrom}
                                            isRequired
                                            controlLabelClassName="color-black"
                                        />
                                    </Col>
                                </>
                            ) : (
                                <Col sm={12} md={6} lg={4} className="mt-1">
                                    <Field
                                        component={RangeDatePicker}
                                        idForm={`${FORM_ID}.search`}
                                        name="dates"
                                        required
                                    />
                                </Col>
                            ))}

                        <Col sm={12} md={mdCol.button} lg={2}>
                            <Button
                                bsStyle="primary"
                                label={enableNewSubmitButton ? "global.filter" : `${FORM_ID}.search.button`}
                                loading={
                                    fetching && !(!isDesktop && optionSelected === "movements" && filtersData.page > 1)
                                }
                                type="submit"
                                image={enableNewSubmitButton ? "filter-icon.svg" : undefined}
                                imageStyle="mr-2"
                                className={classNames("metrocorp__button-filters", {
                                    "text-transform-none": enableNewSubmitButton,
                                })}
                                disabled={
                                    enableNewSubmitButton &&
                                    evalEqualsValues(
                                        filtersData || {},
                                        values,
                                        [
                                            ...(optionSelected !== "holdings" ? ["date"] : []),
                                            ...(optionSelected !== "movements" || !enableRangeDatefield
                                                ? ["dates"]
                                                : []),
                                            ...(optionSelected !== "movements" || enableRangeDatefield
                                                ? ["dateFrom", "dateTo"]
                                                : []),
                                        ],
                                        [
                                            ...(optionSelected === "holdings" ? ["date"] : []),
                                            ...(optionSelected === "movements" && enableRangeDatefield
                                                ? ["dates"]
                                                : []),
                                            ...(optionSelected === "movements" && !enableRangeDatefield
                                                ? ["dateFrom", "dateTo"]
                                                : []),
                                        ],
                                    )
                                }
                            />
                        </Col>
                    </Container>
                </Form>
            )
        );
    }

    renderList = () => {
        const { currentDate } = this.state;
        return (
            <MetrocorpList
                {...this.props}
                handleOpenBottomSheetClick={this.handleOpenBottomSheetClick}
                currentDate={currentDate}
            />
        );
    };

    renderMetrocorpExtracts = () => {
        const { dispatch, clients, embeddedInV3Shell } = this.props;
        const { defaultAccount } = this.state;

        const defaultMinDate = configUtils.getInteger("frontend.show.calendar.resumenes.Metrocorp", 5);

        const getTexts = (key) => {
            const texts = {
                title: "Resúmenes",
                accounts: "Cuenta comitente",
                month: "Fecha de consulta",
                submit: "Descargar",
                pdf: "PDF",
                xls: "XLS",
                csv: "CSV",
            };
            return texts[key];
        };
        const accountsOptions = clients.map((client) => ({ value: client.codClie, label: client.codClie }));

        const defaultMonth = moment()
            .subtract(1, "month")
            .startOf("month")
            .toDate();

        return (
            <MetrocorpExtractsConnected
                accountsOptions={accountsOptions}
                getTexts={getTexts}
                defaultAccount={defaultAccount}
                onSubmit={(data) => {
                    dispatch(
                        metrocorpActions.downloadMonthlyReport({
                            account: data?.account?.value,
                            date: data?.month,
                            format: data?.format || "pdf",
                        }),
                    );
                    this.setState(() => ({
                        defaultAccount: data?.account?.value,
                    }));
                }}
                defaultMonth={defaultMonth}
                minDate={moment()
                    .subtract(defaultMinDate, "years")
                    .toDate()}
                setOpen={(isVisible) => dispatch(metrocorpActions.setReportsDrawerVisible(isVisible))}>
                {!(embeddedInV3Shell && isUxDashboardImprovementsEnabled()) && (
                    <Notification
                        notificationClassname="snackbar__extract"
                        scopeToShow="monthlyReportMetrocorpDrawer"
                    />
                )}
            </MetrocorpExtractsConnected>
        );
    };

    renderContextMenu = () => {
        const { dispatch, clients } = this.props;

        const menuOptions = [
            {
                label: i18nUtils.get("metrocorp.operation.Extracts"),
                callback: () => dispatch(metrocorpActions.setReportsDrawerVisible(true)),
                icon: "Memo",
                iconVariant: "outline",
            },
        ];

        if (clients.length > 0) {
            menuOptions.push({
                label: i18nUtils.get("global.download"),
                callback: () => this.handleExport("pdf"),
                icon: "SendDown",
                iconVariant: "outline",
            });
        }

        return <ContextMenu color="white" menuOptions={menuOptions} />;
    };

    renderRightContentMobile = () => {
        const { isReportDrawerVisible } = this.props;
        return isReportDrawerVisible ? this.renderMetrocorpExtracts.bind(this) : this.renderContextMenu.bind(this);
    };

    renderContent() {
        const {
            isDesktop,
            fetchingDownload,
            activeTotal,
            optionSelected,
            fetching,
            filtersData,
            embeddedInV3Shell,
        } = this.props;
        const { showForm } = this.state;
        const showDrawerExtract = configUtils.getBoolean("frontend.show.metrocorpExtracts.functionalities", false);

        if (isDesktop) {
            return (
                <div className="admin-detail-head px-0 mb-0">
                    <Head onBack={this.handleBack} />
                    <Head
                        centerElement={this.centerElement}
                        // eslint-disable-next-line react/jsx-no-bind
                        rightContent={showDrawerExtract ? this.renderMetrocorpExtracts.bind(this) : null}
                        isFetchingExport={fetchingDownload}
                        exportList
                        handleClick={this.handleExport}
                        handleClickMessage="global.download"
                        csvDownload
                        xlsDownload
                        accessibilityTextId="metrocorp.title.secondPart"
                        imageStyle="mr-2"
                    />
                    <div className="metrocorp__total-assets">
                        <EquivalentTotalBalance
                            balance={activeTotal}
                            isDesktop={isDesktop}
                            title="metrocorp.balance.activeTotal"
                            bold
                        />
                    </div>
                    <div className="mt-3 mb-1">{this.rowButtons()}</div>
                    <PageLoading loading={fetching} className="line-loader">
                        {this.modalDetail()}
                        {this.renderForm()}
                        {this.renderList()}
                    </PageLoading>
                </div>
            );
        }

        return (
            <>
                {!(embeddedInV3Shell && !isDesktop) && (
                    <Head
                        centerElement={this.centerElement}
                        headerClassName="blue-main-header-mobile"
                        centerContentClassName="mx-5"
                        accessibilityTextId="metrocorp.title.secondPart"
                        isFetchingExport={fetchingDownload}
                        onBack={this.handleBack}
                        downloadImageWhite={!fetching}
                        handleClickMessage="global.download"
                        handleClick={this.handleExport}
                        hasInlineButtons
                        exportList={!fetching && !showDrawerExtract}
                        uniqueDownload={!showDrawerExtract}
                        // eslint-disable-next-line react/jsx-no-bind
                        rightContent={showDrawerExtract ? this.renderRightContentMobile() : null}
                    />
                )}
                {this.rowButtons()}
                {!isDesktop && (
                    <Col xs={12} className="justify-content-end d-flex">
                        <Button
                            block
                            className="btn-link p-0 right"
                            label={showForm ? "echeq.button.hideFilter" : "echeq.button.seeFilter"}
                            onClick={() => this.setState((prev) => ({ ...prev, showForm: !prev.showForm }))}
                        />
                    </Col>
                )}
                <PageLoading
                    loading={
                        fetching &&
                        !(
                            !isDesktop &&
                            (optionSelected === "movements" || optionSelected === "futureValues") &&
                            filtersData.page > 1
                        )
                    }
                    className="screen-loader">
                    {this.renderForm()}
                    <div className={`metrocorp__total-acount ml-1 ${isIOS && "px-3"}`}>
                        <EquivalentTotalBalance
                            balance={activeTotal}
                            isDesktop={isDesktop}
                            title="metrocorp.balance.activeTotal"
                            bold
                            block
                        />
                    </div>
                    {this.renderList()}
                </PageLoading>
            </>
        );
    }

    render() {
        const { isDesktop, embeddedInV3Shell } = this.props;

        return (
            <>
                {!embeddedInV3Shell && (
                    <Notification
                        scopeToShow={FORM_ID}
                        notificationClassname={classNames({ "navbar-fixed-top": !isDesktop })}
                    />
                )}
                <div className="metrocorp__page">{this.renderContent()}</div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    fetching: metrocorpSelectors.getFetching(state),
    fetchingDownload: metrocorpSelectors.getFetchingDownload(state),
    activeTotal: metrocorpSelectors.getActiveTotal(state),
    holdings: metrocorpSelectors.getHoldings(state),
    dateHoldings: metrocorpSelectors.getDateHoldings(state),
    futureValues: metrocorpSelectors.getFutureValues(state),
    movements: metrocorpSelectors.getMovements(state),
    fullMovementsList: metrocorpSelectors.getFullMovementsList(state),
    fullMovementsListToDownload: metrocorpSelectors.getFullMovementsListToDownload(state),
    filtersData: metrocorpSelectors.getFiltersData(state),
    clients: metrocorpSelectors.getClients(state),
    optionSelected: metrocorpSelectors.getOptionSelected(state),
    isReportDrawerVisible: metrocorpSelectors.isReportDrawerVisible(state),
    fechingReport: metrocorpSelectors.getFetchingMonthlyReport(state),
    lastPathname: statusSelectors.getPathname(state) || "",
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: true,
        validateOnBlur: true,
        mapPropsToValues: (props) => ({
            principalAccount: props.clients && props.clients.length > 0 ? props.clients[0].codClie : "",
            species: "all",
            date: moment(),
            dateFrom: moment(),
            dateTo: moment(),
        }),
        validationSchema: (props) =>
            Yup.lazy((values) => {
                const { optionSelected } = props;
                const enableRangeDatefield = configUtils.getBoolean(
                    "frontend.show.RangeDatePicker.functionalities",
                    false,
                );

                let validations = {
                    principalAccount: Yup.string().required(
                        i18nUtils.get(`${FORM_ID}.search.principalAccount.error.required`),
                    ),
                    species: Yup.string().required(i18nUtils.get(`${FORM_ID}.search.species.error.required`)),
                };

                if (optionSelected === "holdings") {
                    validations = {
                        ...validations,
                        date: Yup.date()
                            .nullable()
                            .required(i18nUtils.get(`${FORM_ID}.search.date.error.required`)),
                    };
                }

                if (optionSelected === "movements" && !enableRangeDatefield) {
                    validations = {
                        ...validations,
                        dateFrom: values.dateTo
                            ? Yup.date()
                                  .nullable()
                                  .max(values.dateTo, i18nUtils.get(`${FORM_ID}.search.dateFrom.max.error`))
                                  .required(i18nUtils.get(`${FORM_ID}.search.date.error.required`))
                            : Yup.date()
                                  .nullable()
                                  .required(i18nUtils.get(`${FORM_ID}.search.date.error.required`)),
                        dateTo: values.dateFrom
                            ? Yup.date()
                                  .nullable()
                                  .min(values.dateFrom, i18nUtils.get(`${FORM_ID}.search.dateTo.min.error`))
                                  .required(i18nUtils.get(`${FORM_ID}.search.date.error.required`))
                            : Yup.date()
                                  .nullable()
                                  .required(i18nUtils.get(`${FORM_ID}.search.date.error.required`)),
                    };
                }
                if (optionSelected === "movements" && enableRangeDatefield) {
                    validations = {
                        ...validations,
                        dates: Yup.mixed().test(
                            "dates",
                            i18nUtils.get(`${FORM_ID}.validation.range.date`),
                            ([from, to]) => from && to,
                        ),
                    };
                }

                return Yup.object().shape({
                    ...validations,
                });
            }),
        handleSubmit: ({ principalAccount, species, date, dateFrom, dateTo, dates }, formikBag) => {
            const { dispatch, optionSelected, clients, filtersData } = formikBag.props;
            const enableFrontendPagination = configUtils.getBoolean("metrocorp.tenencia.tipo.functionalities", false);
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

            const selectedClient = clients.filter((client) => client.codClie === principalAccount)[0];
            const newDateFrom = enableRangeDatefield && dates ? dates[0] : dateFrom;
            const newDateTo = enableRangeDatefield && dates ? dates[1] : dateTo;

            if (enableFrontendPagination && optionSelected === "movements" && filtersData) {
                const accountChanged = principalAccount !== filtersData.principalAccount;
                const dateFromChanged = !moment(newDateFrom).isSame(moment(filtersData.dateFrom), "day");
                const dateToChanged = !moment(newDateTo).isSame(moment(filtersData.dateTo), "day");

                if (!accountChanged && !dateFromChanged && !dateToChanged) {
                    dispatch(
                        metrocorpActions.updateFiltersData({
                            principalAccount,
                            species,
                            dateFrom: newDateFrom,
                            dateTo: newDateTo,
                        }),
                    );
                    dispatch(metrocorpActions.setLocalPage(1));
                    return;
                }
            }

            dispatch(
                metrocorpActions.listMetrocorp(
                    optionSelected,
                    `${selectedClient.nombre} ${selectedClient.apellido}`,
                    principalAccount,
                    species,
                    date,
                    newDateFrom,
                    newDateTo,
                    1,
                ),
            );
        },
    }),
    resizableRoute,
)(MetrocorpMain);
